import { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router";
import {
  createQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";

import SubNavigation from "../../components/Header/SubNavigation";
import ConfirmModal from "../../components/Modals/ConfirmModal";
import UsersModal from "../../components/Modals/UsersModal";

import {
  Section,
  Alert,
  Spinner,
  Table,
  Icon,
  DropdownMenu,
  UncontrolledDropdown,
  DropdownToggle,
  NotificationManager,
} from "design-react-kit";
import { useContext } from "react";
import UserContext from "../../store/user-context";
import { filterHandler, listOfRoles, notifyUser } from "../../services/helpers";

import "../../assets/Users.css";
import Footer from "../../components/Footer";
import TableSearch from "../../components/Tables/TableSearch";

const Users = () => {
  const [users, setUsers] = useState([]);
  const [results, setResults] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [selectedUserClients, setSelectedUserClients] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedUserRoles, setSelectedUserRoles] = useState(null);
  const [userToBeRemoved, setUserToBeRemoved] = useState(null);

  const userContext = useContext(UserContext);

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      getAllUsers();
    }, 100);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.selectedClientFiscalCode]);

  const getAllUsers = () => {
    setIsLoading(true);
    sendApiRequest(
      "User/GetAllUsers",
      "GET",
      true,
      { fiscalCode: userContext.selectedClientFiscalCode, flowId: null },
      signIn,
      signOut,
      navigate,
      createQueryString,
      userContext
    ).then((response) => {
      if (response !== undefined) {
        if (response.errors !== null) {
          setError(response.errors);
          setIsLoading(false);
        } else {
          setUsers(response.data.users);
          setResults(response.data.users);
          setIsLoading(false);
        }
      }
    });
  };

  const modalOpenHandler = (e, user) => {
    setModalOpen(true);
    setTimeout(() => {
      if (user !== undefined) {
        document.querySelector("#userEmail").value = user.email;
        document.querySelector("#userEmail").setAttribute("user-id", user.id);
        document.querySelector(".modal-title").textContent = "Modifica Utente";
        document.querySelector(".toggles .form-check-input").checked =
          user.isActive;
        document.querySelector(".toggles").style.display = "block";
        document.querySelector(".toggles-span").style.display = "flex";
        document.getElementById("user-save").disabled = true;
        const userClients = [];
        user.codes.map((client) =>
          userClients.push({ value: client.code, label: client.name })
        );
        const userRoles = [];
        user.roles.map((ur) => {
          const userRole = listOfRoles.find((role) => role.value === ur);
          return userRoles.push({
            value: userRole.value,
            label: userRole.label,
          });
        });
        setSelectedUserClients(userClients);
        setSelectedUser(user);
        setSelectedUserRoles(userRoles);
      } else {
        document.querySelector(".toggles .form-check-input").checked = false;
        document.querySelector(".toggles").style.display = "none";
        document.querySelector(".toggles-span").style.display = "none";
        document.getElementById("user-save").disabled = true;
        setSelectedUserClients(null);
        setSelectedUser(null);
        setSelectedUserRoles(null);
      }
      document.querySelector(".modal-content").classList.add("scale");
    }, 100);
  };

  const modalCloseHandler = () => {
    document.querySelector(".modal-content").classList.remove("scale");
    setTimeout(() => {
      setModalOpen(false);
    }, 600);
  };

  const confirmModalOpenHandler = (e, user) => {
    setConfirmModalOpen(true);
    setTimeout(() => {
      document.querySelector(".modal-email").textContent = user.email;
      setUserToBeRemoved(user.id);
    }, 600);
  };

  const confirmModalCloseHandler = () => {
    setConfirmModalOpen(false);
  };

  const handleTypologyChange = (selectedOption) => {
    setSelectedUserClients(selectedOption);
  };

  const handleRolesChange = (selectedOption) => {
    setSelectedUserRoles(selectedOption);
  };

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const columns = [
    "Email",
    "Ruoli",
    "Utente Attivato",
    "Data Creazione",
    "Tipologie Servizio abilitate",
    "",
  ];

  const showIsActive = (isActive) => {
    return isActive ? (
      <Icon icon="it-check" fill="#005A9A" role="button" />
    ) : (
      <Icon icon="it-close" fill="#005A9A" role="button" />
    );
  };

  return (
    <Fragment>
      <SubNavigation page="users" openModalHandler={modalOpenHandler} />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && (
          <div className="d-flex flex-column align-items-end justify-content-start">
            <div className="d-flex align-items-start justify-content-end w-100">
              <TableSearch
                items={users}
                filterHandler={filterHandler}
                setResults={setResults}
                text={"Cerca per email"}
                column={"email"}
              />
              <span title="Aggiornare i dati della tabella">
                <Icon
                  icon="it-refresh"
                  fill="#06c"
                  className="ml-3 mt-1 mb-2"
                  type="button"
                  onClick={(e) => getAllUsers()}
                />
              </span>
            </div>
            <Table responsive className="table">
              <thead>
                <tr>
                  {columns.map((column) => {
                    return (
                      <th key={column} scope="col" className="text-center">
                        {column}
                      </th>
                    );
                  })}
                </tr>
              </thead>
              <tbody>
                {results !== null &&
                  results !== undefined &&
                  results.map((user) => {
                    return (
                      <tr key={user.id}>
                        <td className="text-center email text-nowrap">
                          {user.email}
                        </td>
                        <td className="text-center email text-nowrap">
                          {user.roles !== null &&
                            user.roles !== undefined &&
                            user.roles.length > 0 &&
                            user.roles.map((role) => (
                              <p key={role}>
                                {
                                  listOfRoles.find((r) => r.value === role)
                                    .label
                                }
                              </p>
                            ))}
                        </td>
                        <td className="text-center isActive">
                          {showIsActive(user.isActive)}
                        </td>
                        <td className="text-center creationDate text-nowrap">
                          {user.createdOn}
                        </td>
                        <td className="text-center clients">
                          {user.codes !== null && (
                            <span
                              data-title={user.codes.map(
                                (item) => " " + item.name
                              )}
                            >
                              <Icon icon="it-file" fill="#005A9A" />
                            </span>
                          )}
                          {user.codes === null && (
                            <Icon icon="it-file" fill="#005A9A" />
                          )}
                        </td>
                        <td className="text-center usersTableDropdown">
                          <UncontrolledDropdown className="users-dropdown">
                            <DropdownToggle>
                              <Icon
                                icon="it-more-actions"
                                fill="#06c"
                                role="button"
                              />
                              <Link to={null} className="moreActions">
                                Vedi azioni
                              </Link>
                            </DropdownToggle>
                            <DropdownMenu>
                              <div
                                className="d-flex align-items-center ml-3"
                                onClick={(e) => modalOpenHandler(e, user)}
                              >
                                <Icon
                                  icon="it-pencil"
                                  fill="#06c"
                                  role="button"
                                />
                                <Link
                                  className="edit"
                                  onClick={(e) => modalOpenHandler(e)}
                                >
                                  Modifica
                                </Link>
                              </div>
                              <hr />
                              <div className="d-flex align-items-center ml-3">
                                <Icon
                                  icon="it-delete"
                                  fill="#D70049"
                                  role="button"
                                />
                                <Link
                                  color="#D70049"
                                  className="delete"
                                  onClick={(e) =>
                                    confirmModalOpenHandler(e, user)
                                  }
                                >
                                  Elimina
                                </Link>
                              </div>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </td>
                      </tr>
                    );
                  })}
                {results !== null && results.length === 0 && (
                  <tr>
                    <td colSpan={12}>
                      <Alert className="w-50 mx-auto" color="info">
                        Nessun risultato trovato!
                      </Alert>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Section>
      <div>
        <NotificationManager
          containerId="esempio-avanzato"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
      <UsersModal
        modalOpen={modalOpen}
        modalCloseHandler={modalCloseHandler}
        handleTypologyChange={handleTypologyChange}
        selectedUserClients={selectedUserClients}
        selectedUserRoles={selectedUserRoles}
        handleRolesChange={handleRolesChange}
        selectedUser={selectedUser}
        setUsers={setUsers}
        setResults={setResults}
        notifyUser={notifyUser}
      />
      <ConfirmModal
        confirmModalOpen={confirmModalOpen}
        confirmModalCloseHandler={confirmModalCloseHandler}
        user={userToBeRemoved}
        setUsers={setUsers}
        setResults={setResults}
        notifyUser={notifyUser}
        method={"deleteUserHandler"}
        text={"Stai per eliminare l'utente"}
      />
      <Footer />
    </Fragment>
  );
};

export default Users;
